import bocBridge from '@/assets/js/bocBridge';

const BOC_VERIFY_CODE_TYPE = 9;

function buildChannelGetVerifyCodeParams(params = {}) {
  return {
    verifyCodeType: BOC_VERIFY_CODE_TYPE,
    mobile: params.mobile,
    checkParam: params.checkParam || params.validate,
  };
}

function buildChannelMobileCodeLoginParams(params = {}) {
  return bocBridge.buildChannelMobileCodeLoginParams(params);
}

export default {
  buildChannelGetVerifyCodeParams,
  async channelAutoLogin(params = {}) {
    const actiontype = '/user/clientNoLogin/channel/autoLogin';
    const jsCode = params.jsCode || params.cipherText;
    const payload = bocBridge.buildChannelAutoLoginParams(jsCode);
    return await this.fetch(actiontype, payload, 'bocChannel');
  },
  async channelGetVerifyCode(params = {}) {
    const actiontype = '/user/clientNoLogin/channel/getVerifyCode';
    const payload = buildChannelGetVerifyCodeParams(params);
    return await this.fetch(actiontype, payload, 'bocChannel');
  },
  async channelMobileCodeLogin(params = {}) {
    const actiontype = '/user/clientNoLogin/channel/mobileCodeLogin';
    const payload = buildChannelMobileCodeLoginParams(params);
    return await this.fetch(actiontype, payload, 'bocChannel');
  },
};



// WEBPACK FOOTER //
// ./src/interfaces/modules/boc.js